<div class="wrapper k-d-flex k-align-items-center k-w-full k-justify-content-between">
  <ng-content select="[title-content]"></ng-content>
  <!-- Not really a form, but use k-form here to set the correct styling -->
  <div class="k-d-flex k-align-items-center">
    <div id="month-and-year" class="k-text-center k-font-weight-semibold k-mr-7">
      {{ startOfMonth() | date: "MMMM" }}
      {{ startOfMonth().getFullYear() }}
    </div>

    <div id="controls" class="k-d-flex k-align-items-center">
      <button
        kendoButton
        rounded="full"
        size="large"
        themeColor="secondary"
        (click)="prev()(cd)"
        class="k-mr-2.5"
        [svgIcon]="chevronLeftIcon"
      ></button>

      <a
        role="button"
        [routerLink]=""
        id="today-link"
        class="link-button k-text-center cursor-pointer"
        (click)="today()(cd)"
        >Heute</a
      >

      <button
        kendoButton
        rounded="full"
        size="large"
        themeColor="secondary"
        (click)="next()(cd)"
        [svgIcon]="chevronRightIcon"
        class="k-ml-3"
      ></button>
    </div>
  </div>
</div>
